import { Link } from "react-router-dom"

const BreadCrumbSection = ({page = "home"})=>{
    return(
        <div className="breadcrumb min-h-[300px]">
            <div className="container mx-auto py-[80px]">
                <div className="flex flex-col justify-between px-10 text-white">
                    <p className="font-global_font text-[36px] sm:text-[48px] md:text-[60px] lg:text-[70px] font-medium capitalize z-20">
                        {page}
                    </p>
                    <ul className="breadcrumb-box">
                        <li><Link to={"/home"}>home</Link></li>
                        <li><Link to={`/${page}`}/>{page}</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default BreadCrumbSection